import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterYear'
})
export class FilterYearPipe implements PipeTransform {


  transform(value: any, searchText: any): any {
    if (value.length === 0) {
      return value;
    }
    if (searchText.length === 0 || searchText.length === "") {
      return value;
    }
    return value.filter(function (search: any) {

   
     if(search.publishDt !==undefined){
      return search.publishDt.indexOf(searchText.toLowerCase()) >-1
    }
    else
    {
      return '';
    }

    })
  }

}
